import { FaroText, FaroTextProps } from "@faro-lotv/flat-ui";
import { Stack } from "@mui/material";
import { ReactNode, type JSX } from "react";

type IconTextProps = Pick<FaroTextProps, "dark" | "variant"> & {
  /** An descriptor for the text. */
  label?: string;

  /** The text to display next to the icon. */
  text?: ReactNode;

  /** The icon to display next to the text. */
  icon: JSX.Element;
};

/**
 * @returns Text rendered together with an icon and an optional label.
 */
export function IconText({
  icon,
  text,
  label,
  ...textProps
}: IconTextProps): JSX.Element {
  return (
    <Stack direction="row" sx={{ alignItems: "center", gap: 1 }}>
      <FaroText
        {...textProps}
        sx={{
          // Avoid misalignment of icon in relation to text
          lineHeight: 0,
        }}
      >
        {icon}
      </FaroText>
      {!!label && !!text ? (
        <FaroText {...textProps} sx={{ opacity: 0.7 }}>
          {label}
          {": "}
        </FaroText>
      ) : null}
      {!!text && <FaroText {...textProps}>{text}</FaroText>}
    </Stack>
  );
}
